import { Component } from '@angular/core';

@Component({
  selector: 'simple-card',
  styleUrls: ['./simple-card.component.scss'],
  templateUrl: './simple-card.component.html',
})
export class SimpleCardComponent {}
